import { CartSettings, InjectedCartProps, withCart as withCartFactory } from '@grandvisionhq/next'

import { deliveryResolverFactory } from '../../util/delivery-resolver-factory'

export const settings: CartSettings = {
  deliveryResolverFactory,
  maximumQuantity: 10,
  isDiscountCodeEnabled: true,
  showCartDiscountOnLineItem: false,
  showShippingMethod: true,
  showSubTotal: true,
  showTotalDiscount: true,
  multiDiscountType: true,
  hideStockAndDeliveryOnLineItem: true,
}

export type { InjectedCartProps }

export const withCart = withCartFactory(settings)
